export default "__VITE_ASSET__CqaCrzt9__"